import { render, staticRenderFns } from "./Certification.vue?vue&type=template&id=6c4ac496&scoped=true"
import script from "./Certification.vue?vue&type=script&lang=js"
export * from "./Certification.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/W9_form/certification.css?vue&type=style&index=0&id=6c4ac496&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4ac496",
  null
  
)

export default component.exports